<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-3 ga-3">
      <b-input
        v-model="requestData.search"
        :loading="$loading.isLoading('serverList')"
        :placeholder="searchPlaceholder || 'Пошук...'"
        class="w-100"
        hide-details>
      </b-input>
      <slot name="action-button"></slot>
    </div>

    <div class="mb-3">
      <b-section-loader :loading="$loading.isLoading('serverList')">
        <slot
          v-if="items.length > 0"
          :items="items"
          :request-data="requestData"
          name="items"></slot>
        <div v-else class="w-100 text-center mt-3">
          <span class="text-disabled">Дані не знайдено</span>
        </div>
      </b-section-loader>
    </div>
    <b-pagination
      v-if="requestData.lastPage > 1"
      v-model="requestData.currentPage"
      :length="requestData.lastPage"></b-pagination>
  </div>
</template>

<script generic="T" lang="ts" setup>
import { reactive, shallowRef, watch } from 'vue'
import { debounce } from 'lodash'
import { handleAsync } from 'best-modules/plugins'
import { Query } from 'best-modules/utils'
import { PaginationList } from 'best-modules/components/server-table/types'
import { BSectionLoader } from 'best-modules/components'

const props = defineProps<{
  requestFunc: (_query: Query) => Promise<PaginationList<T>>
  searchPlaceholder: string
}>()

defineSlots<{
  items(_props: { items: T[]; requestData: typeof requestData }): any
  'action-button'(): any
}>()

const requestData = reactive({
  currentPage: 1,
  lastPage: 1,
  search: null as string | null,
})
const items = shallowRef<Array<T>>([])

const getList = () => {
  return handleAsync('serverList', () => {
    return props
      .requestFunc({
        search: requestData.search,
        page: requestData.currentPage,
      })
      .then(res => {
        if (Array.isArray(res)) {
          items.value = res
          requestData.lastPage = 1
          requestData.currentPage = 1
        } else {
          items.value = res.data
          requestData.lastPage = res.last_page
          requestData.currentPage = res.current_page
        }
      })
  })
}

watch(
  () => requestData.search,
  () => {
    requestData.currentPage = 1
  }
)

watch(
  [() => requestData.search, () => requestData.currentPage],
  debounce(getList, 500)
)

defineExpose({ getList })

getList()
</script>

<style lang="scss" scoped></style>
